import _ from "lodash";

const fsObjectToArray = (obj, keyAs = 'DocumentID') => _.values(_.mapValues(obj, (value, key) => ({ [keyAs]: key, ...value })));

export default fsObjectToArray;
